import React from "react";
import { marquee } from "../mock";

const Marquee = () => {
  // Repeat items enough times for a seamless loop
  const items = [];
  for (let i = 0; i < 6; i++) items.push(...marquee);

  return (
    <div className="relative overflow-hidden bg-[#16204a] py-4">
      <div className="marquee-track flex w-max items-center gap-8 whitespace-nowrap">
        {items.map((item, idx) => (
          <div key={idx} className="flex items-center gap-8">
            <span className="text-2xl md:text-3xl font-extrabold text-white">
              {item}
            </span>
            <span className="h-2 w-2 rounded-full bg-[#f5c842]" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
